const metadata = {
    basicInformation: '基本情報',
    category: 'カテゴリー',
    categoryRequired: 'カテゴリーは必須です',
    categoriesLoading: 'カテゴリーを読み込み中…',
    categoriesLoadFailed: 'カテゴリーを取得できませんでした。再試行してください。',
    categoriesEmpty: 'カテゴリーがまだ設定されていません。「一般」を選んで登録できます。',
    description: '説明',
    descriptionRequired: '説明は必須です',
    descriptionHelp: 'ドキュメントの内容について簡単に説明してください',
    department: '部署',
    none: 'なし',
    tags: 'タグ',
    tagsPlaceholder: '検索性を向上させるためのタグを追加',
    tagsHelp: '候補から選択するか、カスタムタグを入力してください',
    addCustomTag: 'カスタムタグを追加',
    add: '追加',
    classificationSecurity: '分類とセキュリティ',
    classification: '分類',
    public: '公開',
    publicDesc: '組織外で共有可能',
    internal: '社内',
    internalDesc: '社内使用限定',
    confidential: '機密',
    confidentialDesc: 'アクセス制限あり',
    defaultAccessLevel: 'デフォルトアクセスレベル',
    privateOnly: 'プライベート（自分のみ）',
    teamDepartment: 'チーム（部署内）',
    organizationEveryone: '組織（全員）',
    allowShare: '他のユーザーがこのドキュメントを共有できるようにする',
    allowDownload: '他のユーザーがこのドキュメントをダウンロードできるようにする',
    continueToUpload: 'アップロードを続行',
    metadataNote: 'このメタデータは選択された{{count}}個の{{files}}に適用されます。',
    file: 'ファイル',
    files: 'ファイル',
    // #1223 PR 2: AI提案runの状態と再試行。レビューUIが描画する。
    taxonomy: {
      panelTitle: 'メタデータ分類',
      panelDescription: 'AIの提案を確認し、確定または却下します。確定は人の操作のみで行われます。',
      loadFailed: '分類情報を取得できませんでした',
      reviewFailed: '分類の更新に失敗しました',
      empty: 'この文書にはまだ分類がありません',
      facet: {
        source_scope: '文書の範囲',
        domain: '領域',
        document_type: '文書種別',
        authority: '権威性',
        product: '製品',
        project: 'プロジェクト',
        customer: '顧客',
      },
      section: {
        confirmed: '確定済み',
        migrated: '移行済み',
        suggested: 'AIの提案',
      },
      action: {
        confirm: '確定',
        reject: '却下',
        confirming: '確定中…',
        rejecting: '却下中…',
        confirmTerm: '{{name}}を確定',
        rejectTerm: '{{name}}を却下',
        confirmingTerm: '{{name}}を確定中…',
        rejectingTerm: '{{name}}を却下中…',
      },
      confidence: '確信度 {{percent}}%',
      lowConfidence: '確信度が低い候補',
      singleValueHint: 'この項目は一つだけ選べます。別の候補を確定するには、先に確定済みの値を却下してください。',
      deprecatedTerm: 'この用語は廃止されています',
      aiProvenance: 'AI提案 / {{version}}',
      unresolvableTerm: 'この用語は解決できないため操作できません',
      // 用語ごとの根拠。domainがReasonCodeを閉じたのは、まさにこれを訳すためである。
      reason: {
        filename_signal: 'ファイル名から',
        heading_signal: '見出しから',
        body_signal: '本文から',
        category_mapping: '既存カテゴリーから',
        default_fallback: '既定値',
      },
      refusal: {
        unknownCode: '選択した用語はこのテナントの用語集にありません',
        deprecatedTerm: 'この用語は廃止されているため、新しく付与できません',
        noActiveTaxonomy: '分類体系が設定されていないため、分類を変更できません',
        duplicateChange: '同じ用語への操作が重複しています',
        cardinalityViolation: 'この項目は一つだけ選べます。先に確定済みの値を却下してください',
        migratedNotConfirmable: '移行された分類は確定できません。却下のみ可能です',
        termNoLongerAvailable: 'この用語は利用できなくなりました',
        notAssigned: 'この分類は既に外されています',
        confirmNotApplied: '他の人が先にこの用語を確定しました。最新の状態を再読み込みしました',
      },
      suggestionRun: {
        notAttempted: 'AI提案は未実行です',
        pending: 'AI提案の順番待ちです',
        running: 'AI提案を実行中です',
        succeeded: 'AI提案が完了しました',
        succeededNoCandidates: 'AI提案は完了しましたが、該当する候補はありませんでした',
        failedNotRetryable: 'AI提案は実行できませんでした。再試行はできません。',
        failed: 'AI提案に失敗しました',
        attemptCount: '試行回数: {{count}}',
        candidateCount: '候補: {{count}}件',
      },
      // 1 error_code = 1 文字列。原因ごとに次の行動が違うため、まとめない。
      suggestionError: {
        provider_timeout: 'AI応答がタイムアウトしました。再試行してください。',
        provider_error: 'AIサービスに接続できませんでした。再試行してください。',
        invalid_output: 'AIの応答が形式を満たさなかったため、候補は保存されていません。',
        no_active_taxonomy: '分類体系が設定されていないため、AI提案を実行できません。',
        extraction_unavailable: '本文の抽出がまだ完了していません。抽出後に再試行してください。',
        extraction_failed: '本文の抽出が失敗したため、AI提案を実行できません。'
          + '抽出を再実行してから再試行してください。',
        no_extractable_text: '抽出できる本文がありません（画像のみのPDFなど）。'
          + '本文を含むバージョンをアップロードしてから再試行してください。',
        internal_error: '内部エラーで候補を保存できませんでした。再試行してください。',
      },
      retry: {
        failed: 'AI提案の再試行に失敗しました',
        action: 'AI提案を再試行',
        retrying: '再試行中…',
        started: 'AI提案の再試行を開始しました',
        alreadySucceeded: 'この文書のAI提案は既に完了しています',
        runInProgress: 'AI提案は既に実行中です',
        forbidden: 'この文書のラベルを編集する権限がありません',
      },
    },
  };

export default metadata;
